import { useState, useRef } from 'react';
import AvatarEditor from 'react-avatar-editor'
import Dropzone from 'react-dropzone'
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  Button
} from '@heroui/react';

const ProfileImageModal = ({user, setUser, dismissModal, setBanner}) => {
  const [image, setImage] = useState(user?.avatar);
  const [error, setError] = useState();
  const [updated, setUpdated] = useState(false);
  const editor = useRef(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setImage(URL.createObjectURL(file));
    setUpdated(true);
  };

  const deletePicture = async() => {
    let fd = new FormData();
    fd.append('image_file', '');
    fd.append('avatar', '');
    const u = await fetch(`/api/v1/users/${user._id || user.id}`, {method: 'PUT', body: fd});
    if (u.status === 200 || u.status === 422) {
      const data = await u.json();
      if (data['user']) {
        setError('');
        setBanner('Picture deleted!');
        setUser(data['user']);
        dismissModal();
      } else {
        if (data['error'] && u.status === 422) {
          setError(data['error']);
        } else {
          setError(`Unknown error update user ${user?.email}: ${u.status}`);
        }
      }
    }
  };

  const submitImage = async () => {
    setBanner();
    setError();
    let headers = {}
    headers['Content-Type'] = 'multipart/form-data';;
    let fd = new FormData();
    const data = editor.current.getImageScaledToCanvas().toDataURL();
    const res = await fetch(data);
    const blob = await res.blob();
    fd.append('avatar', blob, 'userImage.png');
    const u = await fetch(`/api/v1/users/${user._id || user.id}`, {method: 'PUT', body: fd});
    if (u.status === 200 || u.status === 422) {
      const data = await u.json();
      if (data['user']) {
        setError('');
        setBanner('Picture updated!');
        setUser(data['user']);
        dismissModal();
      } else {
        if (data['error'] && u.status === 422) {
          setError(data['error']);
        } else {
          setError(`Unknown error update user ${user?.email}: ${u.status}`);
        }
      }
    }
  };

console.log(" IMAGE: " + image);
console.log(" IMAGE json: " + JSON.stringify(image));

  return (
    <Modal isOpen={true} isDismissable={true} onClose={dismissModal}>
      <ModalContent>
        <ModalHeader className='flex flex-col gap-1'>
          Update Picture
        </ModalHeader>
        <ModalBody>
          { error && <span style={{fontSize: '14px', color: '#ff0000'}}>{error}</span> }

          <Dropzone
            onDrop={(dropped) => {setUpdated(true); setImage(dropped[0])}}
            noClick
            noKeyboard
            style={{ width: '250px', height: '250px' }}
          >
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                <span style={{fontSize: '15px'}}>Drag and drop your profile image here</span>
                <AvatarEditor ref={editor} width={348} height={348} image={image} />
                <input {...getInputProps()} />
              </div>
            )}
          </Dropzone>

          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <input style={{display: 'none'}} id='file-upload' type='file' onChange={handleImageUpload} />
            <label className='upload-button' for='file-upload'>Choose Picture</label>
            { image && image.toString().indexOf('avatars/avatar.png') === -1
              && <label className='upload-button' style={{marginLeft: '6px'}} onClick={() => deletePicture()}>Delete Picture</label>
            }
          </div>
          <Button onPress={() => submitImage()} color={updated ? 'success' : 'default'}
                  style={{marginTop: '10px', marginBottom: '10px'}}>
            Submit
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default ProfileImageModal;
